<app-mainscreen>
  <app-simple-page-heading [breadcrumbs]="['Dashboard > Customers']" title="Customers" ></app-simple-page-heading>
  <div class="box_container mt-4 pt-2 rounded-bottom1-0">
      <div class="box-header mb-4 w-100 pl-2">
          <label class="m-0 box_title_22 pl-1"> Customers </label>
      </div>
      <div class="row w-100">
          <div class="col-md-3 position-relative" *ngIf="userType =='2'">
            <select id="distributorId" name="distributorId" placeholder=" " class="form-control input_" [(ngModel)]="distributorId" (change)="bindResellerDDL()">
              <option *ngFor="let dis of distributorList" [value]="dis.id">
                  {{dis.name}}
              </option>
              </select>
              <label for="distributorId" class="label_">Distributor</label>
          </div>
          <div class="col-md-3 position-relative" *ngIf="userType =='2' || userType =='3'">
            <select id="resellerId" name="resellerId" placeholder=" " class="form-control input_" [(ngModel)]="resellerId"  (change)="bindAgentDDL()">
              <option *ngFor="let dis of resellerList" [value]="dis.id">
                  {{dis.name}}
              </option>
              </select>
              <label for="distributorId" class="label_">Reseller</label>
          </div>
          <div class="col-md-3 position-relative">
            <select id="agentId" name="agentId" placeholder=" " class="form-control input_" [(ngModel)]="agentId">
              <option *ngFor="let agt of agentList" [value]="agt.id">
                  {{agt.name}}
              </option>
            </select>
            <label for="agentId" class="label_">Agent</label>
          </div>
          <div class="col-md-1">
            <app-custom-button text="Filter" [width]="'auto'" [height]="'34px'" leadingIconName="" (click)="getCustomerDetails()">                    
            </app-custom-button>
        </div>
      </div>
    </div>	  
    <app-table-view
    [visibleColumnData] = "visibleColumnData"
    [visibleColumnsId] = "visibleColumnsId"
    [graphdata]="graphdata"
    [graphHeader]="graphHeader"
    title=""
    tableBackground="var(--grey3)"
    [showIconButtonEnd]="true"
    [showPaginator]="true"  
    (onActionClick)="onActionClick($event)"
    [canCreate]="canCreate"
    [canView]="canView"
    [canDelete]="canDelete"
    [canEdit]="canEdit"
    className="rounded-top1-0"
    [showLoader]="showLoader"
  ></app-table-view>
  <app-stepper-dialog></app-stepper-dialog>
  <!-- <div style="height:30px"></div>
  <app-distributor-create></app-distributor-create> -->
  <!-- <app-distributor-view></app-distributor-view> -->
  <!-- <app-distributor-edit></app-distributor-edit> -->
  </app-mainscreen>